namespace $.$$ {

	const { rem } = $mol_style_unit

	$mol_style_define( $eve_radio_labelled, {
		justifyContent: 'flex-start',
		gap: rem( 0.5 ),
	} )
}

